import { useEffect } from "react";
import { ApkEnvStorageKey } from "../config/const";

export const useApkEnvHook = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const apk = queryParams.get("apk");

  useEffect(() => {
    if (apk && apk === "true") {
      localStorage.setItem(ApkEnvStorageKey, apk);
    }
  }, [apk]);

  return {
    isApkEnv: () =>
      localStorage.getItem(ApkEnvStorageKey) === "true" || apk === "true",
  };
};
